import styled from "styled-components";

export const Container = styled.div`
  
	@media (min-width: 992px) {
		//padding-top: 75px;
	}
`;
